import { ISuggestionV2 } from '../repositories/text-search/entities/suggestions_query_string/SuggestionV2';
import { ISuggestion } from '../types/suggestions';

export const prepareSuggestions = (suggestions: ISuggestionV2[]): ISuggestion[] => {
  return suggestions.map(({ text, queryString, type, isUserSuggest, isDefault, geo, icon }) => ({
    query: text,
    icon: icon ?? undefined,
    url: `/cat.php?${queryString}`,
    type,
    geo: geo ?? undefined,
    isUserSuggest: !!isUserSuggest,
    isDefault: isDefault ?? undefined,
  }));
};
